let gridGeometry;
let HIT_RADIUS;

/**
 * Creates grid from container
 */
export function createGridHTML(gridArr) {
  const app = document.getElementById("app");
  app.innerHTML = `
    <button id="copyLink" class="text-xl text-white bg-sky-950 rounded-2xl shadow-l px-5 py-3 transition duration-100 linear active:scale-95">New Game</button>
    <div id="score" class="text-xl text-white rounded-2xl shadow-l"><p>0</p></div>
    <div id="gridContainer">
      <svg id="path-layer"></svg>
      <div id="grid" class="grid-cols-4 gap-6"></div>
    </div>
  `;

  const container = document.getElementById("gridContainer");
  const grid = document.getElementById("grid");
  grid.innerHTML = ""; // If grid elements already exist, delete them

  for (let i = 0; i < 16; i++) {
    const cell = document.createElement("div");
    cell.className = "cell text-3xl text-white shadow-lg rounded-2xl flex justify-center items-center rounded shadow";
    cell.style.cssText = `--i: ${i}`;
    cell.textContent = gridArr[i];
    cell.id = "cell-"+i;
    grid.appendChild(cell);
  }

  container.appendChild(grid);
  return container;
}

/**
 *  Could be called above, but I want to make it explicit that measuring the grid
 *  and thus, setting `gridGeometry` is done AFTER DOMing the grid HTML.
 */
export function measureGrid(container) {
  const rect = container.getBoundingClientRect();

  const cells = [...container.querySelectorAll(".cell")];

  gridGeometry = cells.map((cell, index) => {
    const r = cell.getBoundingClientRect();

    return {
      index,
      row: Math.floor(index / 4),
      col: index % 4,
      cx: r.left + r.width / 2 - rect.left,
      cy: r.top + r.height / 2 - rect.top,
      bounds: {
        left: r.left - rect.left,
        right: r.right - rect.left,
        top: r.top - rect.top,
        bottom: r.bottom - rect.top
      }
    };
  });

  return gridGeometry;
}

/**
 * Given pointer coordinates px, py; find the index of the cell at that point.
 * Remember: coordinates are relative to the gridContainer.
 */
export function getCellAtPoint(px, py) {
  let best = null;
  let minDist = Infinity;

  for (const cell of gridGeometry) {
    const dx = cell.cx - px;
    const dy = cell.cy - py;
    const d = dx * dx + dy * dy;

    if (d < HIT_RADIUS * HIT_RADIUS && d < minDist) {
      minDist = d;
      best = cell.index;
    }
  }
  return best;
}

export function getGridGeometry() {
  return gridGeometry;
}

export function setHitRadius(val) {
  HIT_RADIUS = val;
}

